<!-- workaround for a bug in development: navigation bar would not appear when after live code change -->
@if (showSupportMode) {
  <span class="support-mode">Support-Ansicht</span>
}
<mat-toolbar color="primary">
  <mat-toolbar-row>
    @if (headerText | async; as header) {
      @if (header.fwLink) {
        <a
          class="detail-link"
          [href]="header.fwLink"
          target="_blank">
          {{ header.content }}
          <i class="material-icons external-link-icon">build_circle</i>
        </a>
      } @else {
        {{ header.content }}
      }
    }

    <nav mat-tab-nav-bar color="accent" [tabPanel]="tabPanel">
      <a
        mat-tab-link
        [routerLink]="['/vehicles']"
        routerLinkActive
        #vehicles="routerLinkActive"
        [active]="vehicles.isActive"
        [routerLinkActiveOptions]="{ exact: true }"
        (click)="clearSearchFilter()">
        {{ 'NAV_BAR.LIST' | translate }} ({{ getActiveVehicleCount() | async }})
      </a>

      <a
        mat-tab-link
        [routerLink]="['cardata-container']"
        routerLinkActive
        #tds="routerLinkActive"
        [active]="tds.isActive">
        {{ 'NAV_BAR.CREATE' | translate }}
      </a>

      @if (isAdmin) {
        <a
          #admin="routerLinkActive"
          [active]="admin.isActive"
          [routerLink]="['admin']"
          mat-tab-link
          routerLinkActive>
          Admin
        </a>
      }

      <a
        mat-tab-link
        [routerLink]="['/help']"
        routerLinkActive
        #help="routerLinkActive"
        [active]="help.isActive">
        Help
      </a>
    </nav>
    <mat-tab-nav-panel #tabPanel>
      <router-outlet />
    </mat-tab-nav-panel>
    @if (showDealerChange) {
      <button
        (click)="changeDealer()"
        color="accent"
        mat-raised-button
        class="change-dealer">
        Händlerwechsel
      </button>
    }
  </mat-toolbar-row>
</mat-toolbar>
<!-- Application wide progress bar shown below navigation -->
<div [hidden]="showProgressBar() === false">
  <mat-progress-bar mode="indeterminate" />
</div>
<router-outlet />
